export default Object.freeze({
  DIRECT: 'DIRECT',
  FROM_RECEIVED_AMOUNT: 'FROM_RECEIVED_AMOUNT',
});
